import React, { useEffect } from "react";
import Select from "react-select";
import { differenceInDays } from "date-fns";

import {
  starRatingDefaultResponse,
  starRatingTransactionResponse,
  performanceScreensConstants,
  MENU_PLACEMENT,
  FILTER_LABEL,
} from "../../../admin-screens/constants";
import {
  PERFORMANCE_FILTER_DEFAULT_MAX_STAR,
  PERFORMANCE_FILTER_DEFAULT_MIN_STAR,
  PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT,
  PERFORMANCE_FILTER_DAY_OFFSET,
} from "../../constants";
import { screenSize } from "../../../../constants";
import {
  Option,
  ValueContainer,
  CustomCheckbox,
  useWindowWidth,
  updateStarRatingSelectedOptions,
} from "../../../../shared";
import CustomDateFilter from "../../../../shared/components/dateFilter/customDateFilter";
import { customStyle } from "./performanceStarDateFilter.styles";

const { GUEST_SENTIMENTS, GUEST_TRANSACTION, TRANSACTION, SENTIMENT } =
  performanceScreensConstants;

/**
 * Shared Transaction/Sentiment + star multi-select + date filter
 * for store / group / manager performance screens.
 */
const PerformanceStarDateFilter = (props) => {
  const {
    dateState,
    setMaxStar,
    setMinStar,
    setDayCounts,
    setDateState,
    setStarValue,
    selectedOption,
    setSelectedOption,
    selectedRatingOption,
    handleRatingOptionChange,
    isStarSelectControlled = false,
    cardClassName = "notification-form shadow card px-2",
    starSelectClassName = "star-ranking rounded bg-secondary bg-opacity-25",
    useResponsiveStarWidth = true,
  } = props;

  const windowWidth = useWindowWidth();

  //Set Filter Value
  const handleFilterChange = (e) => {
    const updatedSelectedOption = updateStarRatingSelectedOptions(
      e,
      selectedRatingOption
    );

    //Extract unique filter values using Set
    const uniqueFilters = [
      ...new Set(updatedSelectedOption.map((item) => item.filter)),
    ];
    setStarValue(uniqueFilters);

    const maxStarSet = new Set();
    const minStarSet = new Set();

    e.forEach((item) => {
      maxStarSet.add(item.maxStar);
      minStarSet.add(item.minStar);
    });

    setMaxStar([...maxStarSet]);
    setMinStar([...minStarSet]);

    const sortedArray = [...e].sort((a, b) => {
      const starA = parseFloat(a.value);
      const starB = parseFloat(b.value);
      return starA - starB;
    });
    setSelectedOption(sortedArray);

    if (!sortedArray.length) {
      setMaxStar(PERFORMANCE_FILTER_DEFAULT_MAX_STAR);
      setMinStar(PERFORMANCE_FILTER_DEFAULT_MIN_STAR);
    }
  };

  //Getting selected days to display in column header
  useEffect(() => {
    const { startDate, endDate } = dateState;
    const daysCount =
      differenceInDays(endDate, startDate) + PERFORMANCE_FILTER_DAY_OFFSET;
    setDayCounts(daysCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateState]);

  return (
    <div className="container-fluid pt-3">
      <div className={cardClassName}>
        <div className="card-body py-4">
          <div className="d-flex">
            <CustomCheckbox
              name="transaction"
              value={GUEST_TRANSACTION}
              label={TRANSACTION}
              selectedOption={selectedRatingOption}
              labelClassNames="d-flex align-items-center mr20"
              inputClassNames="mr5"
              onChange={handleRatingOptionChange}
            />
            <CustomCheckbox
              name="sentiment"
              value={GUEST_SENTIMENTS}
              label={SENTIMENT}
              selectedOption={selectedRatingOption}
              labelClassNames="d-flex align-items-center mr20"
              inputClassNames="mr5"
              onChange={handleRatingOptionChange}
            />
          </div>
          <Select
            className={
              useResponsiveStarWidth
                ? `${starSelectClassName} ${
                    windowWidth > screenSize.LAYOUT_DESKTOP ? "w-25" : "w-50"
                  }`
                : starSelectClassName
            }
            name="star"
            options={
              selectedRatingOption === GUEST_SENTIMENTS
                ? starRatingDefaultResponse
                : starRatingTransactionResponse
            }
            components={{
              IndicatorSeparator: () => null,
              Option,
              ValueContainer: ValueContainer,
            }}
            isMulti
            hideSelectedOptions={false}
            closeMenuOnSelect={false}
            getOptionLabel={(option) => option.label}
            onChange={handleFilterChange}
            placeholder={FILTER_LABEL.ALL}
            isSearchable
            maxMenuHeight={PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT}
            menuPlacement={MENU_PLACEMENT.AUTO}
            styles={customStyle}
            {...(isStarSelectControlled
              ? { value: selectedOption || [] }
              : {})}
          />
          <hr />
          <CustomDateFilter dateState={dateState} setDateState={setDateState} />
        </div>
      </div>
    </div>
  );
};

export default PerformanceStarDateFilter;
